import React, { Component } from 'react';



export default class UserGuide extends React.Component {
	render() {
		return (
			<div className="container margin-top-100">
				<h3 className='bold-font blackColor'>r3 User and Content Policy</h3>
				{/* <span className='bold-semifont para mt-2'>We’re equally passionate about <br></br> consumers, the private and public sectors.</span> */}
				<p className='light-font para mt-2'>By using and posting content on Rate.Review.Repeat [r3] [this
					website], you agree to abide by this policy and all other relevant policies or
					guidelines. We reserve the right to remove any content, in whole or part, that violates
					this policy or any other applicable policy/guideline or for any other reason at
					our sole discretion. We unequivocally reserve the right to:</p>

				<ul>
					<li>Moderate content, users, and the functions of this website.</li>
					<li>Violations may result in the restriction, suspension or termination of your account. In the event of repeated or severe violations, we may suspend or permanently deactivate the account(s).</li>
					<li>If a serious breach has occurred, or endangerment is detected, or law(s) has/have been broken, then relevant authorities will be contacted.</li>
				</ul>

				<p className='light-font para mt-2'>
					Remember, r3 seeks to create a safe community of conscientious
					reviewers with the sole purpose of helping consumers in their decision-making,
					and assisting organisations in becoming better. The best reviews are passionate
					and personal because they offer a rich narrative, a wealth of detail, and provide
					guidance to other consumers. r3 does not take sides, so we expect you to stand
					behind your review – make it count!
				</p>

				<h3 className='bold-font blackColor mt-2'>Content Guidelines</h3>
				<p className='light-font para mt-2'>
					Rate.Review.Repeat [r3] allows users to contribute different kinds
					of content, including but not limited to reviews, photos, videos, events,
					votes, tips, direct messages, and more. In order to build a platform of trust,
					it is imperative that reviews are useful, informative, and do not expose our
					community to harm. Therefore, Rate.Review.Repeat [r3] expects that all reviews
					strictly adhere to the following:
				</p>

				<ul>
					<li>
						<span className='bold-semifont para mt-2'>Personal experience: </span>
						<p className='light-font para mt-2'>This is your review so write about your firsthand consumer experience, not what you heard from someone else. Tell your own story without resorting to cheap-shots and allegations. Reviews are most helpful when they provide unbiased information. Therefore, we don't allow individuals or entities who own or are affiliated with a listing or experience to post reviews of their business, nor do we allow individuals who are confirmed to offer competing listings or experiences to post reviews of their direct competitors.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Accuracy: </span>
						<p className='light-font para mt-2'>It is vital that your review is factually correct and honest. State your opinions, but don't exaggerate or misrepresent your experience.</p>
					</li>


					{/* <li>
						<span className='bold-semifont para mt-2'>Review updates:  </span>
						<p className='light-font para mt-2'>Review updates should reflect a new experience or interaction with the business. Don't tell the same old story you've already told. If you'd like to add new insight to an old experience, you can edit your review within <span className='redColor'>30 days of posting it.</span></p>
					</li> */}


					<li>
						<span className='bold-semifont para mt-2'>Inappropriate content:</span>
						<p className='light-font para mt-2'>Colourful language is fine, but there's no need for threats, harassment, racism, gender-based discrimination, religious prejudice, lewdness, hate speech, and other displays of bigotry.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Conflicts of interest:</span>
						<p className='light-font para mt-2'>Contributions should be unbiased and objective and you shouldn’t write reviews of your own business or employer, your friends’ or relatives’ business, your peers or competitors in your industry, or businesses in your networking group. </p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Promotional content: </span>
						<p className='light-font para mt-2'>Unless approved, any promotional content will be removed. Relevance: Please make sure your contributions are relevant and appropriate to the forum. For example, reviews aren't the place for rants about a business's employment practices, political ideologies, extraordinary circumstances, or other matters that don't address the core of the consumer experience.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Privacy: </span>
						<p className='light-font para mt-2'>Don’t publicise other people’s private and personal information. Please don’t post close-up photos or videos of other patrons without their permission, and please don’t post other people’s full names unless you’re referring to service providers who are commonly identified by or commonly share their own full names.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Intellectual property:</span>
						<p className='light-font para mt-2'>Don’t swipe content from other sites or users. Write your own reviews and take your own photos and videos.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Demanding payment: </span>
						<p className='light-font para mt-2'>Beyond simply asking for a refund to remedy a bad experience, you should not use removing or posting your review as a way to extract payment from a business, regardless of whether you’ve been a customer.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Incentivisation: </span>
						<p className='light-font para mt-2'>Reviews that exhibit indications of incentivisation or direct competition. It is not allowed to incentivise positive reviews, to use the threat of a negative review to manipulate a desired outcome, or to influence another’s review with the promise of compensation.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Use of force or extortion: </span>
						<p className='light-font para mt-2'>Any attempt to use reviews or review responses to force a person to do something they aren’t obligated to do is a misuse of reviews, and won’t be allowed. Users of Rate.Review.Repeat [r3] are not allowed to use positive reviews for promises of compensation or to threaten negative reviews if a desired outcome is not met.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Irrelevant or bot review: </span>
						<p className='light-font para mt-2'>Reviews that contain no relevant information will be removed. Reviews that contain mostly irrelevant information are also subject to removal, but only where the otherwise relevant information would not be expected to meaningfully inform the decisions of other community members.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Political attacks: </span>
						<p className='light-font para mt-2'>the service provided r3 is for consumers and organisations to prosper by growing and improving with feedback, whether good or bad as well as being a platform to provide information for sound decision-making. As such, r3 is apolitical and political attacks of any kind will not be tolerated. This is not the right platform for taking political pot-shots.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Competitor reviews:</span>
						<p className='light-font para mt-2'>Reviews written by competitors for the purpose of dissuading others from using the services other listings or experiences, is not allowed. Violations of this may, without warning, automatically result in the restriction, suspension or termination of your r3 account.</p>
					</li>

					<li>
						<span className='bold-semifont para mt-2'>Review removal: </span>
						<p className='light-font para mt-2'> We believe that a healthy review system is one that respects and protects our community’s genuine feedback. For that reason, we take the removal of any review very seriously and as a last option. In short, to keep reviews relevant, acceptable and valid, we humbly recommend avoiding the following:</p>
						<ul>
							<li>Commentary about a person/organisation’s social, political or religious views.</li>
							<li>Profanity, name calling, and assumptions about a person’s character or personality.</li>
							<li>Content that refers to circumstances entirely outside of another’s control.</li>
							<li>Content about services not related to r3 (e.g. Political parties, Government, etc.)</li>
						</ul>
						<span className='bold-semifont para mt-2 redColor'>The following content is never allowed:</span>
					</li>
					<ul>
						<li>Content created solely for the purpose of advertising or other commercial content, including company logos, links, or company names.</li>
						<li>Spam, unwanted contact, or content that is shared repeatedly in a disruptive manner.</li>
						<li> Content that endorses or promotes illegal or harmful activity, or that is sexually explicit, violent, graphic, threatening, or harassing.</li>
						<li>Content that is discriminatory or violates basic tenets of human or universal rights.</li>
						<li>Attempts to impersonate another person, account, or entity, including a representative of r3 or any other organisation.</li>
						<li>Content that is illegal or that violates another person’s or entity’s rights, including intellectual property rights and privacy rights.</li>
						<li>Content that includes another person’s private or confidential information, including content that is sufficient to identify private or confidential information.</li>
						<li> Reviews and profiles that provide fraudulent, false, misleading, or deceptive information.</li>
						<li>Trolling or repeatedly targeting community members, individuals or organisations.</li>
					</ul>


				</ul>

				<h3 className='bold-font blackColor mt-2'>Reporting a review that violates this policy</h3>
				<p className='light-font para mt-2'>When we receive a report of a review that violates this policy or any other relevant policy, we may at our discretion remove the review from our platform to investigate the report. This will be communicated to the reviewer.
					To report a review, <a href='/contactus'>contact us.</a>
				</p>


				<h3 className='bold-font blackColor mt-2'>Can I remove or respond to a review I disagree with?</h3>
				<p className='light-font para mt-2'>Reviews are only removed if they violate our policies. Review responses will be posted immediately after you publish them, and they cannot be edited once posted.</p>

			</div >
		)
	}
};